import { useLayoutEffect, useRef, type ReactNode } from "react";
import { useStore } from "../../store.ts";
import { FULL_FEATURES } from "@ic/engine";

/** Hidden children are not mounted: there are no underlying digits, titles, or copied values. */
export function ProfitMask() {
  if (!FULL_FEATURES) return null;
  return <span className="profit-mask" data-profit-hidden="true"><span>报价与利润已隐藏</span><small>Quote &amp; Profit Hidden</small></span>;
}
export function ProfitOnly({ children }: { children?: ReactNode }) {
  const visible = useStore((s) => s.sheet.quote);
  return FULL_FEATURES && visible ? <>{children}</> : <ProfitMask />;
}
/** Costs stay confidential even when the current sheet's quote mode is off. */
export function ProfitWarning() {
  return <div className="profit-warning" role="note" id="profitWarning">
    <b>内部成本资料：严禁向客户、工厂或其他外部人员分享页面、截图或导出文件。</b>
    <span>CONFIDENTIAL: Internal costing data. Do not share pages, screenshots or exports with customers, factories or other external parties.</span>
  </div>;
}

/** Keep navigation and privacy controls together; dialogs follow the actual header height. */
export function GlobalHeader({ children }: { children: ReactNode }) {
  const ref = useRef<HTMLElement>(null);
  useLayoutEffect(() => {
    const element = ref.current;
    if (!element) return;
    const update = () => document.documentElement.style.setProperty("--global-header-height", `${element.getBoundingClientRect().height}px`);
    update();
    const observer = new ResizeObserver(update);
    observer.observe(element);
    return () => { observer.disconnect(); document.documentElement.style.removeProperty("--global-header-height"); };
  }, []);
  return <header className="global-header" ref={ref}><ProfitWarning />{children}</header>;
}
